@let canReadDistributionList = userContext.canReadDistributionList();
@let canCreateDistributionList = userContext.canCreateDistributionList();

<div class="distribution-list-page">
  <topo-data-table-server
    #table
    [isActive]="true"
    [tableHidden]="isTableLoading"
    [datasource]="datasource"
    [columns]="columDefs"
    [headerLabel]="'MANAGEMENT.COMMUNICATION-CENTER.DISTRIBUTION-LISTS' | translate"
    [newLabel]="'MANAGEMENT.COMMUNICATION-CENTER.NEW-DISTRIBUTION-LIST' | translate"
    [headerIcon]="'assets/images/people-group.svg'"
    [showNewButton]="canCreateDistributionList && selectedDistributionListType == DistributionListType.None"
    [showHeader]="true"
    [showSearch]="canReadDistributionList"
    [showMenu]="false"
    [showRowGroups]="false"
    [showSystemFields]="true"
    [enableInfiniteScroll]="false"
    [enableServerSort]="true"
    [enableServerFilter]="true"
    (paginate)="onPaginate($event)"
    (newClick)="new()"
    [getRowId]="getRowId"
    (takeChanged)="onTakeChanged($event)"
    (storeUpdatedCalled)="onGridDataLoaded()"
    [skip]="skip"
    [take]="take"
  [totalCount]="totalCount"></topo-data-table-server>

  <topo-new-distribution-list></topo-new-distribution-list>
  <topo-confirm-delete
    [isActive]="!!distributionListToDelete"
  (confirmResponse)="confirmDeleteDistributionList($event)"></topo-confirm-delete>
</div>

@if (showType == true) {
  <div
    class="distribution-list-type"
    fxLayout="row"
    fxLayoutAlign="center center">
    <div class="type-header">{{ 'COMMUNICATIONS.COLUMNS.TYPE' | translate }}</div>
    <div class="select is-small is-fullwidth">
      <select
        [(ngModel)]="selectedDistributionListType"
        (change)="distributionListTypeChanged($event)">
        @for (type of distributionListTypes; track type.value) {
          <option
            [ngValue]="type.value">
            {{ type.name }}
          </option>
        }
      </select>
    </div>
  </div>
}
